import React from 'react';
import { Clipboard } from 'lucide-react';
import { Button } from './ui/button';
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from './ui/tooltip';

interface ClipboardButtonProps {
  onClick: () => void;
  tooltipText?: string;
  ariaLabel?: string;
  className?: string;
  disabled?: boolean;
}

export const ClipboardButton: React.FC<ClipboardButtonProps> = ({
  onClick,
  tooltipText = 'Copy',
  ariaLabel,
  className = '',
  disabled = false,
}) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            onClick={disabled ? undefined : onClick}
            disabled={disabled}
            className={`group ${className}`}
            aria-label={ariaLabel || tooltipText}
          >
            <Clipboard className="h-4 w-4 transition-transform duration-200 group-hover:text-[var(--scribane-green)] group-hover:scale-110" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>{tooltipText}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

